// static
export const BOX_MODAL_FRAME_BUS_ID = 'box-modal-standalone'

// dynamic
export const withBoxPaywallFrameBusID = (resourceId: string) =>
  `box-modal-standalone-paywall:${resourceId}`
